import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import DiscountsCreateForm from './DiscountsCreateForm';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { createDiscount } from 'store/actions/discounts/createDiscounts';
import utils from 'helpers/utils';

class DiscountsCreateContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            history,
            dispatchForm,
        } = this.props;

        if (values.percentage && values.percentage > 0) {
            values.percentage = values.percentage / 100;
        }

        return new Promise((resolve) => {
            dispatchForm({
                onError: resolve,
                onSuccess: () => {
                    resolve(history.push('/discounts'));
                },
                values: utils.filterEmptyValues(values),
            });
        });
    }

    render() {
        const {
            translate,
        } = this.props;

        const breadcrumbs = [
            {
                label: translate('resources.discounts.title'),
                link: '/discounts',
            },
            {
                label: translate('actions.create'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.discounts.actions.create') } />

                    <Actions>
                        <ListButton url='/discounts' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <DiscountsCreateForm
                            form='discounts_create'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

DiscountsCreateContainer.propTypes = {
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(createDiscount(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(DiscountsCreateContainer);



// WEBPACK FOOTER //
// ./src/pages/discounts/create/DiscountsCreateContainer.js